import PropTypes from 'prop-types';
import React from 'react';
import { setClassNames } from 'ddc-classnames-js';
import { Button } from 'react-bootstrap';
import { useLabels } from 'wsm-common-data';

const CarouselButton = ({
	direction,
	clickEvent,
	focusEvent = () => null,
	mouseUpEvent = () => null,
	classes = []
}) => {
	const labels = useLabels();
	const text =
		direction === 'right'
			? labels.get('NEXT_OFFER')
			: labels.get('PREVIOUS_OFFER');
	return (
		<Button
			className={setClassNames(['btn-carousel', ...classes])}
			onClick={clickEvent}
			onMouseUp={mouseUpEvent}
			onFocus={focusEvent}
			bsStyle={null}
		>
			<i
				role="presentation"
				aria-hidden="true"
				className={setClassNames([
					'ddc-icon',
					'ddc-icon-carousel-arrow',
					`ddc-icon-carousel-arrow-${direction}`,
					'd-block'
				])}
			/>
			<span className="sr-only">{text}</span>
		</Button>
	);
};

CarouselButton.propTypes = {
	direction: PropTypes.string.isRequired,
	clickEvent: PropTypes.func.isRequired,
	focusEvent: PropTypes.func,
	mouseUpEvent: PropTypes.func,
	classes: PropTypes.arrayOf(PropTypes.string)
};

export default CarouselButton;
